import React from 'react';
import { Map, Set } from 'immutable';
import { connect } from 'react-redux';
import { compose } from 'ramda';

import {AvailHotelDetailMulti} from './AvailHotelDetail.jsx';
import styleFile from './MultiHotelAvail.js';
import SearchOptions from '../../components/functional/SearchOptions';
import { Loading } from '@synergycms_core/components/functional/Loading';
import Button from '@synergycms_core/components/generic/Button';
import { GoogleMap } from '../../components/functional/GoogleMap';
import { AvailAlert } from '../../components/functional/AvailAlert';
import RichText from '@synergycms_core/components/generic/RichText';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { checkAvailSegments, reduceWhileResolved } from '../../utils';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import actions from '../../store/actions.js';
import moment from 'moment';
import Footer from '../../components/functional/Footer/Footer.jsx';

class MultiHotelAvail extends React.Component {
  static displayName = 'MultiHotelAvail';

  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      showMapToolTip: false,
      showMap: false
    };

    if (props.hasSelectionAvail) {
      props.resetSelectionAvail();
    }

    this.onHover = this.onHover.bind(this);
    this.eventShowMapToolTip = this.eventShowMapToolTip.bind(this);
    
  }

  onHover = hotelId => e => {
    e.preventDefault();
    this.setState((state, props) => ({
      hover: hotelId
    }));
  };

  eventShowMapToolTip = hotelId => e => {
    if (hotelId !== this.state.showMapToolTip) {
      this.setState((state, props) => ({
        showMapToolTip: hotelId
      }));
    }
  };

  showMap = e => {
    e.preventDefault();
    this.setState(
      (state, props) => ({
        showMap: !state.showMap
      }),
      () => {
        this.props.showSearchOptionsInHeader(this.state.showMap);
      }
    );
    this.updateBodyStyles(this.state.showMap);
  };

  updateBodyStyles = showMap => {
    if (!showMap) {
        document.body.style.overflow = "hidden";
        window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
        document.body.style.overflow = "auto";
    }
  }

  componentWillUnmount = () => {
    this.props.showSearchOptionsInHeader(false);
  };

  componentDidMount() {

    this.props.triggerEvent();
  }

  render() {
    const {
      maxNights,
      availableHotels,
      hotelsFilter,
      stayLength,
      orderedHotels,
      params,
      group,
      webType
    } = this.props;
    const { classes } = this.props.theme.styles;

    const dateStart = moment(params.get('date'));
    const isDateInvalid = dateStart.startOf('day').isBefore(moment().startOf('day'));

    let alertReason = false;
    if (isDateInvalid) {
      alertReason = 'invalid_date';
    } else if (stayLength >= maxNights) {
      alertReason = 'max_nights';
    } else {
      alertReason = 'no_avail';
    }

    return availableHotels.size ? (
      <div className={classes.defaultStyle}>
        <div className={classes.hotelContent}>
          <SearchOptions innerStyle={'multiHotelSearchOptions'} availableHotels={availableHotels}/>
          <ul>
            <li className={classes.parentBestPrice}>
              <div className={classes.bestPrice}>
                <RichText
                  icon={{ content: '', innerStyle: [classes.bestPriceIcon] }}
                  innerStyle={['roboto13Black']}
                  translate={true}>
                  _%mejor precio garantizado%_
                </RichText>
              </div>
            </li>
            {!!availableHotels.size &&
            !!hotelsFilter.size &&
            orderedHotels // OrderBy hotels
              .filter(hotelId => availableHotels.includes(hotelId) && hotelsFilter.has(hotelId)) // Available hotel && SearchOption Filter
              .map(hotelId => {
                return (
                  <li key={hotelId}>
                    <AvailHotelDetailMulti
                      onHover={this.onHover}
                      eventShowMapToolTip={this.eventShowMapToolTip}
                      key={hotelId}
                      hotelId={hotelId}
                      noWhiteSpace={true}
                    />
                  </li>
                );
              })}
          </ul>
        </div>
        {(this.props.theme.width > 1301 || this.state.showMap) && (
          <div
            className={`${classes.mapContent} ${group === 'eurostarshotels' && webType === 'PORTAL' ? '' : classes.hideTopMap}`}>
            <GoogleMap hover={this.state.hover} showMap={this.state.showMap} hotelToShow={this.state.showMapToolTip}/>
          </div>
        )}
        <Footer />
        {this.props.theme.width < 1301 && (
          <div className={classes.fixedSeeMap}>
            <div className={classes.buttonContainer}>
              <Button
                richText={{
                  text: !this.state.showMap ? '_%ver mapa%_' : '_%ver lista%_',
                  icon: {
                    svg: !this.state.showMap ? 'mapIcon' : 'lista',
                    innerStyle: [classes.svgIcon]
                  },
                  innerStyle: ['uppercase'],
                  translate: true
                }}
                onClick={this.showMap}
                innerStyle={['toggleMainButtonReverse', classes.toggleMapButton]}
              />
            </div>
          </div>
        )}
      </div>
    ) : (
      <div className={classes.defaultStyle}>
        <AvailAlert type={alertReason}/>
        <div className={classes.footer}>
          <Footer />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showSearchOptionsInHeader: show => {
      dispatch(actions.customer.header.show('search_options', show));
    },
    triggerEvent: () => {
      dispatch(actions.events.trigger('show_avail'));
    },
    resetSelectionAvail: () => {
      dispatch(actions.customer.params.updateParams(Map({ selection_avail: null })));
    },
  };
};

const mapStateToProps = store => {
  const hotelsIds = store.getIn(['customer', 'current_hotels']);
  
  const hotelsDescriptives = reduceWhileResolved(store, 'hotels');
  const hotelsAvail = reduceWhileResolved(store, 'avail');
  
  const orderedHotels = store.getIn(['customer', 'order_by', 'orderedHotels']);
  const maxNights = hotelsDescriptives && (hotelsDescriptives.maxBy(hot => hot.get('max_avail')).get('max_avail') || 31);
  
  //ACTIVE LOYALTY
  const availableHotels =
    hotelsAvail &&
    hotelsDescriptives &&
    hotelsAvail
      .filter((hotelAvail, hotelId) =>
        checkAvailSegments(
          store.getIn([
            'avail',
            hotelId,
            store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "multi", "base_query_params"])]),
            'raw_response'
          ])
        )
      )
      .keySeq()
      .map(key => parseInt(key));
  const webType = store.getIn(['customer', 'web_type'], false);
  const lol = {
    maxNights: maxNights,
    hotelsIds: hotelsIds,
    hotelsDescriptives: hotelsDescriptives,
    hotelsAvails: hotelsAvail,
    availableHotels: availableHotels,
    hotelsFilter: store.getIn(['customer', 'filters', 'hotels']) || Set(),
    stayLength: store.getIn(['customer', 'params', 'params', 'stay_length']),
    orderedHotels: orderedHotels,
    webType: webType,
    group: store.get('group', false),
    hasSelectionAvail: store.getIn(['customer', 'selection_avail'], null),
    params: store.getIn(['customer', 'params', 'params']),
  };
  
  return lol;
};

const fragment = props => {

  const engineSygyData = window.frontLoader || window.engine_sygy_data;
  const { webType } = props;
  const group = engineSygyData && engineSygyData.group;
  const corporateLogin = window.LoginUser && +window.LoginUser.tipo_perfil === 1 ? window.LoginUser : null;
  const loyaltyLogin = window.LoginUser && +window.LoginUser.tipo_perfil === 2 ? window.LoginUser : null;
  const userLogIn = (corporateLogin && corporateLogin.usuario !== 'NoLogin') || (loyaltyLogin && loyaltyLogin.usuario !== 'NoLogin');

  return (
    <React.Fragment>
      <Loading
        richText={{
          ucFirst: true,
          innerStyle: ['descriptionText'],
          text: '_%estamos buscando los mejores precios para ti%_',
          translate: true
        }}
        showLoyaltyBanner={webType === 'PORTAL' && group === 'eurostarshotels' && !userLogIn}
      />
    </React.Fragment>
  );
};


export default compose(
  validateAsyncComponent(mapStateToProps, [], fragment),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withThemeJSS({ styleFile, link: true })
)(MultiHotelAvail);
